import { Modal } from 'components/Modal';
import styles from './ModalStartOrder.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import ContentLoader from 'react-content-loader';

export const ModalStartOrder = ({
  setIsShowStartModal,
  onConfirm,
  isLoading,
  isAll = false,
  loadindModal,
}: {
  isShowStartModal: boolean;
  setIsShowStartModal: (e: boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
  isAll?: boolean;
  loadindModal: boolean;
}) => {
  const handleStartOrder = () => {
    onConfirm();
  };

  return (
    <Modal setOpen={setIsShowStartModal}>
      {loadindModal ? (
        <ContentLoader
          speed={2}
          height={'352px'}
          width='500px'
          className={styles.tab_loader}
          backgroundColor={'#FFFFFF'}
          foregroundColor={'#D8E4FB8C'}>
          <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
        </ContentLoader>
      ) : (
        <div className={styles.root}>
          <Title
            className={styles.root_title}
            title={'Подтверди действие на go.skilla.ru'}
          />

          {isAll ? (
            <div className={styles.banner}>
              <div className={styles.bannerText}>
                <span>
                  Будут начаты все заказы, где назначен исполнитель и дата начала СЕГОДНЯ.
                </span>
                <span>
                  {
                    'Чтобы начать отдельные заказы, выбери их из списка и нажми "Начать заказ".'
                  }
                </span>
              </div>
            </div>
          ) : (
            <div>
              {
                'Будут начаты выбранные заказы, где назначен исполнитель и дата начала СЕГОДНЯ.'
              }
            </div>
          )}

          <div className={styles.root_btn}>
            <Button
              onClick={() => setIsShowStartModal(false)}
              theme='outline'
              className={styles.root_btn_cancel}
              size='L'>
              <IconCancel />
            </Button>
            <Button
              onClick={handleStartOrder}
              disabled={isLoading}
              className={styles.root_btn_exit}
              theme='filed'
              size='L'>
              <div>
                Начать
                <IconDone />
              </div>
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};
